import { put, call, takeLatest, takeEvery, all } from 'redux-saga/effects';
import * as types from './types';
import * as api from './api';
import * as actions from './actions';
import { setInsuredDevice } from 'insurance/insuranceContracts/actions';

import { findGenerator, getAllGenerator, updateGenerator } from 'helpers/resourceSagas';

export const find = findGenerator({
  resourceType: 'insuredDevices',
  endpoint: api.find
});

export const fetchFiltered = getAllGenerator({
  resourceType: 'insuredDevices',
  endpoint: api.fetchFiltered,
  endpointArgs: (payload) => [ payload.params ],
});

/*
export const activate = updateGenerator({
  resourceType: 'insuredDevices',
  endpoint: api.activate,
  endpointArgs: ({ id }) => [ id ],
  transformResponse: (resp) => [{}]
});
*/

export function* activate(action) {
  const { id } = action.payload
  const actionProps = {};
  const resourceType = 'insuredDevices';
  const endpoint = api.activate;
  const endpointArgs = ({ id }) => [ id ];
  const transformResponse = (resp) => [{}];
  const args = endpointArgs(action.payload);
  try {
    yield put(actions.activatePending(resourceType, actionProps));
    const resp = yield call(endpoint, ...args);
    yield put(actions.activateSucceeded(resourceType, resp, transformResponse, actionProps));
    yield put(actions.setPurchase(id, resp.data));
  }
  catch (err) {
    yield put(actions.activateFailed(resourceType, err, actionProps));
  }
}

export const cancel = updateGenerator({
  resourceType: 'insuredDevices',
  endpoint: api.cancel,
  endpointArgs: ({ id, params }) => [ id, params ],
  transformResponse: (resp) => [{}]
});

export function* create({ payload }) {
  const { attrs } = payload;
  try {
    yield put(actions.createPending());
    const resp = yield call(api.create, attrs);
    yield put(actions.createSucceeded(resp));
    const device = resp.data;
    yield put(setInsuredDevice(device.contract, device.id));
  }
  catch (err) {
    yield put(actions.createFailed(err));
  }
}

export function* watchFind() {
  yield takeEvery(types.FIND, find);
}

export function* watchFetchFiltered() {
  console.log('watchFetchFiltered')
  yield takeLatest(types.FETCH_FILTERED, fetchFiltered);
}

export function* watchActivate() {
  yield takeLatest(types.ACTIVATE, activate);
}

export function* watchCreate() {
  yield takeLatest(types.CREATE, create);
}

export function* watchCancel() {
  yield takeLatest(types.CANCEL, cancel);
}

export function* watchInsuredDevices() {
  console.log('watchInsuredDevices');
  yield all([
    call(watchFind),
    call(watchFetchFiltered),
    call(watchCreate),
    call(watchActivate),
    call(watchCancel),
  ]);
}
